<template>
  <!-- 1.all-container-start -->
  <div class="main">
    <div class="df-maina-ddtit"><span>购物车</span></div>
    <div class="df-buybox">
      <div class="df-buyboxa"></div>
      <div class="df-buyboxb">
        <div class="df-buyboxba">
          <span class="on"><i>1</i></span
          ><span><i>2</i></span
          ><span><i>3</i></span>
        </div>
        <div class="df-buyboxbb">
          <span class="on">1.我的购物车</span><span>2.填写核对订单信息</span
          ><span>3.成功提交订单</span>
        </div>
      </div>
    </div>
    <div class="df-buya">
      现金礼品(您可以通过支付宝，账户余额，微信支付线支付)
    </div>
    <div class="df-buyb">
      <table cellpadding="0" cellspacing="0">
        <tr>
          <th>
            <el-checkbox v-model="checkAll" @change="handleCheckAllChange"
              >图片</el-checkbox
            >
          </th>
          <th>商品名称</th>
          <th>SKU</th>
          <th>数量</th>
          <th>单价</th>
          <th>库存</th>
          <th>总价</th>
          <th>操作</th>
        </tr>
        <tr v-for="(item, index) of currentPageInfo" :key="index">
          <td>
            <el-checkbox
              v-model="item.checked"
              @change="ckChange(index)"
            ></el-checkbox>
            <img v-if="item.pcImg" :src="item.pcImg" class="img" />
            <img v-else src="../../../images/image.png" class="img" />
          </td>
          <td>{{ item.goodsName || "商品名称" }}</td>
          <td>{{ item.sku || "--" }}</td>
          <td>
            <el-input-number
              v-model="item.amount"
              size="mini"
              :min="1"
              :max="1000"
              step-strictly
              style="width:110px;"
              @change="updateCart(index, item)"
            ></el-input-number>
          </td>
          <td>{{ to_f(item.shopPrice || "0.00") }}</td>
          <td></td>
          <td>{{ to_f(item.shopPrice * item.amount || "0.00") }}</td>
          <td>
            <el-button size="mini" @click="deteleGoods(item)">删除</el-button>
          </td>
        </tr>
        <tr v-if="currentPageInfo.length == 0">
          <td colspan="8" rowspan="8">
            <span class="nobuyData"
              >购物车内暂时没有商品,去首页挑选喜欢的商品</span
            >
          </td>
        </tr>
      </table>
    </div>
    <div class="df-buyc">
      <span class="df-buyca">
        <span class="hands item" @click="clearShoppingCar">
          清空购物车
        </span>
        <span class="hands item" @click="$router.push('/goodsCenter')">
          继续购物
        </span>
      </span>
      总计(元):
      <span style="font-size:18px;color:#e7584f;margin-right:10px;">{{
        to_f(totalPrice)
      }}</span>
      <el-button
        size="small"
        style="background:#e5e4e2;border-color:#97c5e9;padding:7px 20px;margin-left:5px;"
        v-if="currentPageInfo.length != 0"
        @click="goAddAddress"
      >
        去结算
      </el-button>
    </div>

    <!--<div class="middle">
      <div class="area">
        <div class="bottom" v-if="currentPageInfo.length > 0">
          <div
            class="item borderShadow flexStyle2"
            v-for="(item, index) of currentPageInfo"
            :key="index"
          >
            <div class="check">
              <el-checkbox
                v-model="item.checked"
                @change="ckChange(index)"
              ></el-checkbox>
            </div>
            <div class="photo">
              <img v-if="item.pcImg" :src="item.pcImg" class="img" />
              <img v-else src="../../../images/image.png" class="img" />
            </div>
            <div class="name oneLine">
              {{ item.goodsName || "商品名称" }}<br />sku:{{ item.sku || "--" }}
            </div>
            <div class="onePrice">
              单价：{{ to_f(item.shopPrice || "0.00") }}
            </div>
            <div class="allPrice">
              总价：{{ to_f(item.shopPrice * item.amount || "0.00") }}
            </div>
            <div class="allPrice">
              <el-input-number
                v-model="item.amount"
                size="mini"
                :min="1"
                :max="1000"
                step-strictly
                style="width:110px;"
                @change="updateCart(index, item)"
              ></el-input-number>
            </div>
            <div class="btns">
              <el-button
                size="mini"
                type="danger"
                icon="el-icon-delete"
                @click="deteleGoods(item)"
                >删除</el-button
              >
            </div>
          </div>
        </div>
        <div v-else class="bottom2">
          购物车暂无任何非生鲜商品，请去<span
            class="c-animation hands"
            @click="$router.push('/goodsCenter')"
            >商品列表</span
          >进行采购
        </div>
      </div>
    </div>-->
  </div>
  <!-- 1.all-container-end -->
</template>

<script>
import * as math from "mathjs";
import {
  getCartListRequest,
  editCartRequest,
  clearCartRequest,
  delCartRequest,
} from "../../../public/js/service";

export default {
  data() {
    // 1.data
    return {
      currentPageInfo: [], // 1.1.currentPageInfo
      token: "", // 1.2.token
      numberTimer: null, // 1.3.数量timer
      checkAll: false,
    };
  },

  components: {
    // 2.components
  },

  methods: {
    // 3.methods
    goAddAddress() {
      // 3.1.去结算，实则就是去填写地址
      let ary = [];
      for (let j = 0; j < this.currentPageInfo.length; j++) {
        if (this.currentPageInfo[j].checked) {
          ary.push(this.currentPageInfo[j]);
        }
      }
      this.$emit("changeStep", ary);
    },

    getCurrentPageInfo() {
      // 3.2.获取购物车商品列表信息
      let data = {};
      getCartListRequest(data).then((res) => {
        this.currentPageInfo = res.data.map((item) => {
          item.checked = item.isCheck == 0;
          if (item.webSetmealGoodsList && item.setmealId) {
            let price = 0.0;
            for (let j = 0; j < item.webSetmealGoodsList.length; j++) {
              let row = item.webSetmealGoodsList[j];
              let qq = parseInt(row["amount"] || "1");
              let pp = parseFloat(row["shopPrice"] || "99999.00");
              price += qq * pp;
              item.goodsName = row.setmealName;
            }
            item.shopPrice = price;
          }
          return item;
        });
        this.$emit("deteleSuccess");
      });
      console.log(this.currentPageInfo);
    },

    deteleGoods(item) {
      // 3.3.删除购物车内商品
      let _this = this;
      this.$msgbox.confirmButtonClass = "cconfirmButtonClass";
      this.$msgbox({
        title: "提示",
        message: "是否确认删除该商品/组合品吗?",
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        callback(res) {
          if (res == "confirm") {
            _this.confirmDeteleGoods(item);
          }
        },
      });
    },

    confirmDeteleGoods(item) {
      // 3.4.确认删除购物车内商品
      let ids = [];
      ids.push(item.webCartId);
      let data = { ids: ids };
      delCartRequest(data).then((res) => {
        this.$message({
          type: "success",
          message: res.msg,
        });

        setTimeout(() => {
          this.getCurrentPageInfo();
        }, 300);
      });
    },

    clearShoppingCar() {
      // 3.5.清空购物车
      let _this = this;
      this.$msgbox({
        title: "提示",
        message: "是否确认清空购物车?",
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        callback(res) {
          if (res == "confirm") {
            _this.confirmClearShoppingCar();
          }
        },
      });
    },

    confirmClearShoppingCar() {
      // 3.6.确认清空购物车
      clearCartRequest({}).then((res) => {
        if (res) {
          this.$message({
            type: "success",
            message: res.msg,
          });

          setTimeout(() => {
            this.getCurrentPageInfo();
          }, 300);
        }
      });
    },
    updateCart(index, row) {
      let data = {};
      data.index = index;
      data.webCartId = row.webCartId;
      data.amount = row.amount;
      if (data.amount <= 0) {
        // 3.7.1.判断商品数量是不是没有了
        this.$notify({
          title: "提示",
          message: "商品数量最少为1件",
        });
      } else {
        editCartRequest(data).then(() => {
          this.$emit("deteleSuccess");
        });
      }
    },

    goodsNumberParse(item, parse, index) {
      // 3.7.调整商品数量
      clearTimeout(this.numberTimer);

      this.numberTimer = setTimeout(() => {
        let res = item.amount + parse;
        if (res <= 0) {
          // 3.7.1.判断商品数量是不是没有了
          this.$notify({
            title: "提示",
            message: "商品数量最少为1件",
          });
        } else {
          this.confirmParseGoodsNumber(item, res, index);
        }
      }, 300);
    },

    confirmParseGoodsNumber(item, amount, index) {
      // 3.8.确认调整商品数量
      let data = {
        webCartId: item.webCartId,
        goodsId: item.goodsId,
        setmealId: item.setmealId,
        amount: amount,
      };

      editCartRequest(data).then(() => {
        this.currentPageInfo[index].amount = amount;
        this.$emit("deteleSuccess");
      });
    },
    ckChange(v) {
      let webCartId = this.currentPageInfo[v].webCartId;
      let checked = this.currentPageInfo[v].checked;
      let param = { webCartId: webCartId, isCheck: checked ? 0 : 1 };
      editCartRequest(param).then((res) => {
        if (res) {
          // this.$message({
          //   type: "success",
          //   message: res.msg,
          // });
        }
      });
    },

    printFn(value) {
      // 3.9.精度算数
      const precision = 14;
      return Number(math.format(value, precision));
    },

    handleCheckAllChange(val) {
      if (val == true) {
        for (let i = 0; i < this.currentPageInfo.length; i++) {
          this.currentPageInfo[i].checked = true;
        }
      } else {
        for (let i = 0; i < this.currentPageInfo.length; i++) {
          this.currentPageInfo[i].checked = false;
        }
      }
      this.$forceUpdate();
    },
  },

  mounted() {
    // 4.mounted
    if (localStorage.token) {
      this.token = localStorage.token;
      this.getCurrentPageInfo(); // 4.1.getCurrentPageInfo
    }
  },

  computed: {
    // 5.computed
    totalPrice() {
      // 5.1.计算属性-总价格
      let total = 0;
      this.currentPageInfo.forEach((item) => {
        if (item.checked) {
          total = total + item.amount * (item.shopPrice || 9999999.0);
        }
      });

      return this.printFn(total);
    },
  },
};
</script>
<style scoped lang="scss">
$ui-width: 1350px;
@function px2vw($px) {
  @return $px / $ui-width * 100vw;
}

$mainColor1: #e65a5a;
$mainColor2: #dd3242;
$mainColor3: #ff0000;

/* 1.all-container-style-start */
.main {
  width: px2vw(1150px);
  max-width: 1700px;
  margin: 20px auto;
  border-radius: px2vw(7px);
  box-sizing: border-box;
  padding: px2vw(20px);
  font-size: 13px;

  > .top {
    font-size: 14px;
  }

  > .middle {
    margin: 20px 0;

    > .area {
      border-bottom: 1px solid #ddd;
      padding: 20px 0;
      margin-bottom: 20px;

      > .top {
        font-size: 15px;
        font-weight: bold;
        margin-bottom: 10px;
      }

      > .bottom {
        > .item {
          margin-bottom: 10px;
          padding: 20px;
          border-radius: 6px;

          > div {
            flex-shrink: 0;
          }

          > .check {
            width: px2vw(40px);
            height: px2vw(70px);
            max-width: 70px;
            max-height: 70px;
            margin-right: px2vw(10px);
            padding-top: px2vw(30px);
          }

          > .photo {
            width: px2vw(70px);
            height: px2vw(70px);
            max-width: 70px;
            max-height: 70px;
            margin-right: px2vw(10px);
          }

          > .name {
            flex: 1;
          }

          > .onePrice {
            width: px2vw(110px);
            margin-left: px2vw(20px);
          }

          > .allPrice {
            width: px2vw(130px);
            margin-left: px2vw(20px);
          }

          > .number {
            margin: 0 px2vw(20px);

            > div {
              width: px2vw(20px);
              height: px2vw(20px);
              border: 1px solid #ddd;
              margin-left: px2vw(10px);
            }
          }

          > .btns {
            > .btn {
              background-color: $mainColor1;
              color: #fff;
              border-radius: px2vw(4px);
              padding: px2vw(5px) px2vw(20px);
            }
          }
        }
      }

      > .bottom2 {
        text-align: center;
        margin: 20px 0;
        > span {
          color: $mainColor3;
          display: inline-block;
          margin: 0 px2vw(10px);
        }
      }
    }
  }

  > .bottom {
    width: 100%;
    font-size: 13px;
    box-sizing: border-box;

    > .left {
      color: rgb(116, 111, 111);

      > .item {
        margin-right: 20px;
      }
    }

    > .right {
      > .left {
        margin-right: 20px;
        > span {
          font-size: 18px;
          color: $mainColor3;
          padding: 0 px2vw(4px);
          font-weight: bold;
        }
      }

      > .right {
        background-color: $mainColor1;
        color: #fff;
        border-radius: px2vw(4px);
        font-size: 14px;
        padding: 8px 30px;
      }
    }
  }
}
/* 1.all-container-style-start */
</style>
